export const UsdtLogo = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-label="USDT">
    <g fill="none" fillRule="evenodd">
      <circle cx="16" cy="16" r="16" fill="#26A17B" />
      <path
        fill="#FFF"
        d="M17.922 17.383v-.002c-.11.008-.677.042-1.942.042-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658 0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061 1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658 0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118 0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116 0-1.043-3.301-1.914-7.694-2.117"
      />
    </g>
  </svg>
);

export const TrxLogo = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-label="TRON">
    <g fill="none">
      <circle cx="16" cy="16" r="16" fill="#EF0027" />
      <path
        fill="#FFF"
        d="M21.932 9.913L7.5 7.257l7.595 19.112 10.583-12.894-3.746-3.562zm-.232 1.17l2.208 2.099-6.038 1.093 3.83-3.192zm-5.142 2.973l-6.364-5.278 10.402 1.914-4.038 3.364zm-.453.934l-1.038 8.58L9.472 9.487l6.633 5.502zm.96.455l6.687-1.21-7.67 9.343.983-8.133z"
      />
    </g>
  </svg>
);

export const CoinLogo = ({ coin, size }) => (coin === "USDT" ? <UsdtLogo size={size} /> : <TrxLogo size={size} />);

export const COINS = [
  { id: "TRX", name: "TRON", net: "TRX" },
  { id: "USDT", name: "Tether", net: "TRC20" },
];
